import React from 'react';
import { map } from 'lodash';

import matchList from 'modules/match-list';
import useMobileTopMatchItem from './useMobileTopMatchItem';

import './mobileTopMatchItem.scss';

const {
    components: { SportEventRow },
} = matchList;

interface Props {
    zoneId: string;
    sportEventIds: Set<string>;
}

const MobileTopMatchItem: React.FC<Props> = ({ zoneId, sportEventIds }) => {
    const { matchesIds, title } = useMobileTopMatchItem({
        zoneId,
        sportEventIds,
    });

    if (!matchesIds.length) return null;

    return (
        <div styleName="container">
            <div styleName="title">{title}</div>

            <div>
                {map(matchesIds, matchId => (
                    <SportEventRow
                        key={matchId}
                        matchId={matchId}
                        prevMatchId={undefined}
                    />
                ))}
            </div>
        </div>
    );
};

export default React.memo(MobileTopMatchItem);
